// extracted by mini-css-extract-plugin
export default {"shadow":"Button3d_shadow__LT5TY","edge":"Button3d_edge__O9MVy","front":"Button3d_front__BQNky","text":"Button3d_text__xiXB2"};